// extracted by mini-css-extract-plugin
export default {"imageWrapper":"YH-z","videoWrapper":"ZH-z","twoColumnImage":"_H-z","imageCarouselBtn":"aI-z","carouselNextBtn":"bI-z","carouselPrevBtn":"cI-z"};